import { createFileRoute, notFound } from "@tanstack/react-router";

import { ShowcaseCasePage } from "@/features/showcase/showcase-case-page";

/**
 * 事例 1 件。認証ガードは付けない（一覧と同じ理由）。
 * 未知の slug は 404 にする。固定データなので loader で同期的に解決できる。
 */
export const Route = createFileRoute("/showcase/$slug")({
  /*
   * **動的 import にする。** loader を静的 import で書くと、ルート分割の対象が
   * component だけなので事例データ（本文 3 件ぶん・約 38KB）が全ルート共通の
   * 初期チャンクに載り、ログイン画面や各ダッシュボードにも配られてしまう。
   */
  loader: async ({ params }) => {
    const { findShowcaseCase } = await import("@/features/showcase/showcase-data");
    const showcase = findShowcaseCase(params.slug);
    if (!showcase) throw notFound();
    return { showcase };
  },
  component: ShowcaseCaseRoute,
});

function ShowcaseCaseRoute() {
  const { showcase } = Route.useLoaderData();
  /*
   * `key` で事例ごとに作り直す。同じルートの param 変更ではコンポーネントは再マウントされず
   * 再レンダリングになるため、これが無いと**前の事例の状態が持ち越される**
   * （枠内のスクロール位置・開いていたプレビュー・スライドの表示枚数など）。
   * 状態を 1 つ増やすたびにリセット処理を書き足す運用にはしない。
   */
  return <ShowcaseCasePage key={showcase.slug} showcase={showcase} />;
}
